export default class LoginController {
  /* @ngInject */
  constructor(RouterService, GeographyService, LoginService, AuthService, ProductFilterService, $interval, LocalStorageService, AUTH_CONSTANT, HttpService) {
    this.routerService = RouterService;
    this.loginService = LoginService;
    this.authService = AuthService;
    this.geographyService = GeographyService;
    this.productFilterService = ProductFilterService;
    this.localStorageService = LocalStorageService;
    this.$interval = $interval;
    this.AUTH_CONSTANT = AUTH_CONSTANT;
    this.httpService = HttpService;
  }

  $onInit() {
    const {sha1, loggedOut} = this.routerService.location.search();
    const hasToken = this.authService.token();

    if (loggedOut) {
      this.isLoggedOut = loggedOut;
      return;
    }

    if (hasToken) {
      return this.onLoginSuccess();
    }

    return sha1
      ? this.createTokenFromSha1(sha1)
      : this.goToLogin();
  }

  createTokenFromSha1(sha1) {
    this.loginService.createJWT(sha1)
      .then(({jwt}) => {
        this._storeId = this.authService.currentStoreId(jwt);
        if (!this._storeId) {
          return this.httpService.reject({hasInvalidStoreId: true});
        }
        const storePromise = this.geographyService.storeDetail(this._storeId, {}, {
          Authorization: this.authService.createAuthorization(jwt),
        });
        return Promise.all([jwt, storePromise]);
      })
      .then(([jwt]) => {

        this.authService.token(jwt);

        if (this.authService.isAccessingFromExternalInternet() && !this.authService.canAccessFromExternalInternet()) {
          this.blockUserAndShowCountDown({reason: this.AUTH_CONSTANT.ERROR.INTERNET_ROLE});
          return;
        }
        if (this.authService.hasKnownRole()) {
          this.onLoginSuccess();
          return;
        }

        this.blockUserAndShowCountDown({reason: this.AUTH_CONSTANT.ERROR.UNKNOWN_ROLE});
      })
      .catch((err) => {
        if (err.hasInvalidStoreId) {
          this.blockUserAndShowCountDown({reason: this.AUTH_CONSTANT.ERROR.MISSING_STORE});
        } else if (this.isStoreNotFoundError(err)) {
          this.blockUserAndShowCountDown({
            reason: this.AUTH_CONSTANT.ERROR.STORE_NOT_FOUND,
            reasonErrorVariable: this._storeId,
          });
        }
        this.authService.token(null);
      });
  }

  isStoreNotFoundError(err) {
    const rmdGetStoreEndPoint = '/rmd-manager/stores';
    const isRmdEndpoint = err.config.url.includes(rmdGetStoreEndPoint);
    return err.status === 404 && isRmdEndpoint;
  }

  onLoginSuccess() {
    return this.loginCompleted();

    // if (!this.authService.isPersonalShopper()) {
    //   return this.loginCompleted();
    // }
    // this.loginService.getTermsAndConditions(this.authService.username())
    //   .then(() => this.loginCompleted())
    //   .catch(() => {
    //     this.modalFactory.showTermsAndConditions({
    //       user: {
    //         name: this.authService.name(),
    //         surname: this.authService.surname(),
    //         email: this.authService.username(),
    //         company: this.authService.company(),
    //       },
    //     })
    //       .then((modal) => {
    //         modal.close.then(({conditionsAccepted}) => {
    //           if (conditionsAccepted) {
    //             this.geographyService.storeDetail()
    //               .then((storeData) => {
    //                 this.loginService.saveTermsAndConditions(this.authService.createdBy(storeData.market.id));
    //               })
    //               .then(() => this.loginCompleted());
    //           }
    //         });
    //       });
    //   });
  }

  _blockUser({message, error} = this.AUTH_CONSTANT.ERROR.GENERIC, reasonErrorVariable = '') {
    this.authService.token(null);
    this.accessDenied = true;
    this.accessDeniedReason = {
      message,
      error: typeof error === 'function' ? error(reasonErrorVariable) : error,
    };
  }

  _showCountDown() {
    this.isCountDownVisible = true;
    this.timer = 15;
    this.timerPromise = this.$interval(() => this.timer > 0 ? --this.timer : this.clearTimer(), 1000);
  }

  blockUserAndShowCountDown({reason, showCountDown, reasonErrorVariable} = {}) {
    this._blockUser(reason, reasonErrorVariable);
    if (showCountDown !== false) {
      this._showCountDown();
    }
  }

  loginCompleted() {
    const redirectPostLogin = this.localStorageService.get('redirectPostLogin');
    if (redirectPostLogin) {
      this.localStorageService.remove('redirectPostLogin');
      return window.location.href = redirectPostLogin;
    }
    this.routerService.state.go('home');
    this.productFilterService.initFilters();
  }

  goToLogin() {
    window.location = this.loginService.createADFSUrl();
  }

  clearTimer() {
    this.$interval.cancel(this.timerPromise);
    this.loginService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.controller.js